
import { getAppConfig } from "../../../common/config/app-config";

const { lang } = getAppConfig();

export const exploreBrandRangeSectionFacets = [ lang === 'en' ? 'subFamilyEn' : 'subFamilyAr', 'price'];
export const exploreCategoryRangeSectionFacets = [ lang === 'en' ? 'familyEn' : 'familyAr',lang === 'en' ? 'subFamilyEn' : 'subFamilyAr', 'price',lang === 'en' ? 'brandEn' : 'brandAr','priceValueDiscountPercentage'];

export const perPageCount = 20;
